/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountnotfounderror3Inputs */

const en_accountnotfounderror3 = /** @type {(inputs: Accountnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account not found.`)
};

const de_accountnotfounderror3 = /** @type {(inputs: Accountnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto wurde nicht gefunden.`)
};

/**
* | output |
* | --- |
* | "Account not found." |
*
* @param {Accountnotfounderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const accountnotfounderror3 = /** @type {((inputs?: Accountnotfounderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountnotfounderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountnotfounderror3(inputs)
	return de_accountnotfounderror3(inputs)
});
export { accountnotfounderror3 as "accountNotFoundError" }